const host = 'https://fecdn.dongfangfuli.com';
const buckets =  {
  mall: '/mall',
};
const folder = {
  images: '/images',
};

export const Logo = `${host}${buckets.mall}${folder.images}/logo.png`;
